
var i = {
    t: function() {
        try {
            var e = document.getElementById("divicw"),
                t = document.createElement("script");
            // FIXED: Added quotes around the URL and fixed concatenation
            t.src = "https://media.imi.chat/widget/js/imichatinit.js?t=" + new Date().toISOString();
            
            e.insertAdjacentElement("afterend", t);
            t.addEventListener("load", function() {
                console.log(new Date().toISOString(), "Livechat script loaded successfully!");
            });
            t.addEventListener("error", function() {
                console.log(new Date().toISOString(), "Error loading Livechat script");
                i.o(e);
            });
        } catch (e) {
            console.error(e);
        }
    },
    o: function(e) {
        e.insertAdjacentHTML("afterend", '<iframe id="tls_al_frm" frameborder="0" style="overflow:hidden;height:208px;width:394px;position:fixed;display:block;right:48px;bottom:12px;z-index:99999;display:none;"></iframe>');
        var t = document.getElementById("tls_al_frm"),
            n = t.contentWindow,
            d = n.document;
        d.open();
        // FIXED: Escaped the closing script tag (<\/script>) to prevent browser confusion
        d.write("<!doctype html><html><head><meta charset='utf-8'><title>Untitled Document</title><style>body{font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;color:#99a0b0;font-size:14px}.popover__content{background-color:#fbfbfe;padding:1.5rem;border-radius:5px;width:300px;box-shadow:0 2px 5px 0 rgba(0,0,0,0.26);position:relative}.popover__message{font-weight:600;color:#56627c;font-size:16px}.pull-left{float:left}.clearfix{clear:both}.hdr-txt{width:218px;margin-top:3px}.para-txt a{text-decoration:none;color:#005cde}.close-btn{position:absolute;right:15px;top:15px}.close-btn a{text-decoration:none;font-weight:400;color:#56627c;font-size:16px}</style></head><body><div class='popover__content'><div class='close-btn'><a href='#' onclick='closeTLSAlert()'>X</a></div><div class='popover__message'><div class='pull-left hdr-txt'>This browser version is not supported on LiveChat.</div></div><div class='clearfix'></div><p class='para-txt'>Please update your browser to the latest version and re-open the website to access the widget.</p></div><script>function closeTLSAlert(){window.parent.postMessage({key:'close_tls_alert',value:'close_tls_alert',action:'close_tls_alert'},'*');}<\/script></body></html>");
        d.close();
        t.style.display = 'block';
        window.addEventListener('message', function(e) {
            'close_tls_alert' === e.data.action && i.s();
        });
    },
    s: function() {
        var e = document.getElementById('tls_al_frm');
        e && e.remove();
    }
};
i.t();
